<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="zbon"
      :model="model"
      :required-date-value="realDate"
      :use-add-action="false"
      :use-custom-action="false"
      :use-delete-action="false"
      :use-edit-action="false"
      entity-name="ZBonList"
      @selectedItems="showList"
    >
      <template #footer>
        <v-btn
          v-if="selectedList.length > 1"
          :loading="btnLoading"
          class="mr-2"
          color="amber lighten-4 black--text"
          dark
          elevation="0"
          @click="outputPdf()"
        >
          <v-icon left>
            mdi-email-fast-outline
          </v-icon>
          {{ $t('pdf') }}
        </v-btn>
        <v-btn
          v-if="selectedList.length > 1"
          :loading="btnLoading"
          class="mr-2"
          color="amber lighten-4 black--text"
          elevation="0"
          @click="print()"
        >
          <v-icon left>
            mdi-printer
          </v-icon>
          {{ $t('print') }}
        </v-btn>
      </template>
      <template #[`item.reprint`]="{item}">
        <v-btn
          :loading="btnLoading"
          icon
        >
          <v-icon
            small
            @click="exportPDF(item)"
          >
            mdi-file-pdf-box
          </v-icon>
        </v-btn>
        <v-btn
          :loading="btnLoading"
          icon
        >
          <v-icon
            small
            @click="printSingleItem(item)"
          >
            mdi-printer
          </v-icon>
        </v-btn>
        <v-btn
          :loading="btnLoading"
          icon
        >
          <v-icon
            small
            @click="generateZBonPDF(item)"
          >
            mdi-email-fast-outline
          </v-icon>
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>

import Zbon from '@/model/dataLayer/api/export/Zbon'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import { newNewPrintZbon, newPrintZBon } from '@/model/dataLayer/service/otherService'
import { showSuccessMessage } from '@/model/utils/utils'
import { standardFormatter, today } from '@/model/utils/DateRepository'
import dayjs from 'dayjs'
import hillo from 'hillo'

export default {
  components: { IkDataTable },
  data: function () {
    return ({
      selectedList: [],
      btnLoading: false,
      model: Zbon
    })
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    realDate () {
      const now = dayjs().subtract(3, 'hour').subtract(59, 'minute')
      if (this.$parent.dateRange[0] === today) {
        return [standardFormatter(now.startOf('year')), today]
      } else {
        return this.$parent.dateRange
      }
    }
  },
  methods: {
    exportPDF (item) {
      this.btnLoading = true
      window.open(hillo.axios.defaults.baseURL + 'ZBon.php?op=exportPDF&id=' + item.zbonNumber)
      this.btnLoading = false
    },
    showList (selectedItems) {
      this.selectedList = selectedItems.map(it => it.zbonNumber)
    },
    async print () {
      this.btnLoading = true
      try {
        for (const i of this.selectedList) {
          await newPrintZBon(i)
        }
        showSuccessMessage('print_success')
      } catch (e) {

      }
      this.btnLoading = false
    },
    async generateZBonPDF (item) {
      this.btnLoading = true
      await newPrintZBon(item.zbonNumber, 1, 1)
      showSuccessMessage(this.$t('submit_success'))
      this.btnLoading = false
    },
    async outputPdf () {
      this.btnLoading = true
      try {
        await newNewPrintZbon(this.selectedList)
        showSuccessMessage(this.$t('submit_success'))
      } catch (e) {

      }
      this.btnLoading = false
    },

    async printSingleItem (item) {
      this.btnLoading = true
      await newPrintZBon(item.zbonNumber)
      showSuccessMessage(this.$t('print_success'))
      this.btnLoading = false
    }
  }
}
</script>
